module.exports = __webpack_public_path__ + "img/fuwubaoz_3.6479319e.png";